import React, { useEffect, useState, Fragment, useRef } from 'react';
import { Link } from 'react-router-dom';

import ReactHTMLTableToExcel from 'react-html-table-to-excel';

//Headlessui for MODAL
import { Dialog, Transition } from '@headlessui/react';

//Toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Icons
import { BsXLg } from 'react-icons/bs';

//Skeleton
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

//APIS
import { seminerGetAll } from '../../../apis/seminer';
import { donem, donemAktif } from '../../../apis/donem';
import { danismanOnayMail } from '../../../apis/danisman';

const TumBasvurular = () => {
  const [loading, setLoading] = useState(false); // Skleton için kullanılacak

  //STATES

  const [open, setOpen] = useState(false);
  const [seminerId, setSeminerId] = useState();

  //LIST STATE
  const [seminerLIST, setSeminerLIST] = useState([]);
  const [donemLIST, setDonemLIST] = useState([]);
  const [aktifDonemLIST, setAktifDonemLIST] = useState();
  const [selectedAktifDonem, setSelectedAktifDonem] = useState(0);

  // Helper FUNCTION

  const handelPostMailDanisman = async () => {
    let result = await danismanOnayMail({ donemId: selectedAktifDonem });
    if (result.status === 200) {
      toast.success('Onay bekleyen başvurular için mail gönderilmiştir.', {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else {
      toast.error('Bir hata oluştu lütfen daha sonra tekrar deneyiniz', {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  //API FUNCTIONS

  const getSeminerLIST = async () => {
    let result = await seminerGetAll(1, { donemId: selectedAktifDonem });
    //console.log(result)
    if (result.status === 200) {
      setSeminerLIST(result.data);
    }
  };

  const getDonemLIST = async () => {
    setLoading(true);
    let result = await donem();
    if (result.status === 200) {
      setDonemLIST(result.data);
      setLoading(false);
    }
  };

  const getDonemAktif = async () => {
    let result = await donemAktif();
    if (result.status === 200) {
      setAktifDonemLIST(result.data);
      setSelectedAktifDonem(result.data.donemActive.donemId);
    } else {
      let result = await donem();
      setSelectedAktifDonem(result.data[0].donemId);
    }
  };

  const isMounted = useRef(true);

  useEffect(() => {
    if (isMounted.current) {
      isMounted.current = false;
      return;
    }
    getSeminerLIST();
    //eslint-disable-next-line
  }, [aktifDonemLIST, selectedAktifDonem]);

  useEffect(() => {
    getDonemAktif();
    getDonemLIST();
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <ToastContainer />
      <main className="text-slate-500 text-sm transition-all">
        <div className="py-5">
          <div className="w-full px-4 sm:px-6 md:px-8">
            <div className="container mx-auto flex flex-col md:flex-row justify-between  md:items-start mb-3 md:mb-0">
              <h1 className="page-title leading-6 font-normal text-lg mb-2 md:mb-6 text-slate-500 ">
                Gelen Başvurular
              </h1>
              {donemLIST?.length > 0 ? (
                <div>
                  <select
                    value={selectedAktifDonem}
                    onChange={(e) => {
                      setSelectedAktifDonem(e.target.value);
                    }}
                    className="sd-form-input text-xs"
                  >
                    {donemLIST?.map((item, key) => (
                      <option key={key} value={item.donemId}>
                        {item.donemName}
                      </option>
                    ))}
                  </select>
                </div>
              ) : null}
            </div>
            <div className="container mx-auto space-y-4">
              <div className="kapsama relative w-full flex flex-col lg:flex-row gap-4">
                <div className="w-full">
                  <div className="bg-white rounded-lg p-4 min-h-0 overflow-x-auto mb-6">
                    <div className="flex justify-between items-center">
                      <h1 className="mb-4 font-semibold">
                        Bekleyen Başvurular
                      </h1>
                      {aktifDonemLIST?.donemActive?.donemId ? (
                        <button
                          onClick={(e) => handelPostMailDanisman()}
                          className="mb-4 bg-red-500 hover:bg-red-600 text-white px-2 rounded-sm py-1 transition-all"
                        >
                          Danışmanlara Uyarı Maili Gönder
                        </button>
                      ) : null}
                    </div>
                    {loading ? (
                      <Skeleton
                        baseColor="#e2e8f0"
                        width="100%"
                        count={3}
                        height={20}
                      />
                    ) : (
                      <table className="w-full table-auto">
                        <thead className="bg-slate-100">
                          <tr>
                            <td className="px-4 py-2 whitespace-nowrap">
                              Başvuru No
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap hidden lg:table-cell">
                              Öğrenci
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap hidden lg:table-cell">
                              Enstitü / Dönem
                            </td>
                            <td className="py-2">Durum</td>
                            <td className="py-2">İşlemler</td>
                          </tr>
                        </thead>
                        <tbody className="text-xs">
                          {seminerLIST?.filter(
                            (item) => item.seminerDurum === 1
                          ).length > 0 ? (
                            seminerLIST
                              ?.filter((item) => item.seminerDurum === 1)
                              .map((item, key) => (
                                <tr
                                  key={key}
                                  className="even:bg-slate-50 odd:bg-white"
                                >
                                  <td className="px-4 py-3 whitespace-nowrap">
                                    <strong className="underline">
                                      <Link
                                        to={
                                          '/seminer-print/' + item.seminerCode
                                        }
                                        target="blank"
                                      >
                                        {item.seminerCode}
                                      </Link>
                                    </strong>
                                    <dl className="lg:hidden">
                                      <dd className="">
                                        {item.ogrenci.ogrenciNo}
                                      </dd>
                                      <dd className="">
                                        {item.ogrenci.ogrenciAdiSoyadi}
                                      </dd>
                                      <dd className="">{item.enstituName}</dd>
                                    </dl>
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                                    <div>{item.ogrenci.ogrenciNo}</div>
                                    <div>{item.ogrenci.ogrenciAdiSoyadi}</div>
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                                    <div>{item.enstituName}</div>
                                    <div>{item.donem.donemName}</div>
                                  </td>
                                  <td className="py-3 whitespace-nowrap">
                                    {item.seminerDurum === 1 ? (
                                      <span className="bg-orange-200 text-orange-600 py-1 px-2 rounded-3xl">
                                        Bekliyor
                                      </span>
                                    ) : item.seminerDurum === 2 ? (
                                      <span className="bg-teal-200 text-teal-600 py-1 px-2 rounded-3xl">
                                        Onaylandı
                                      </span>
                                    ) : (
                                      <span className="bg-red-200 text-red-600 py-1 px-3 rounded-3xl">
                                        Rededildi
                                      </span>
                                    )}
                                  </td>
                                  <td className="py-3 whitespace-nowrap space-x-2">
                                    <button
                                      onClick={() => {
                                        setSeminerId(item.seminerId);
                                        setOpen(true);
                                      }}
                                      className="bg-sky-600 text-white hover:bg-sky-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-sky-400 outline-offset-2"
                                    >
                                      Görüntüle
                                    </button>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan={3} className="px-4 py-3">
                                Kayıt bulunamamıştır.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="bg-white rounded-lg p-4 min-h-0 overflow-x-auto mb-6">
                    <div className="flex justify-between items-center mb-4">
                      <h1 className="font-semibold">Onaylanan Başvurular</h1>
                      <div>
                        {seminerLIST?.filter((item) => item.seminerDurum === 2)
                          .length > 0 ? (
                          <>
                            <ReactHTMLTableToExcel
                              className="text-white bg-slate-400 px-2 py-1.5 rounded text-xs"
                              table="tablo"
                              filename="Seminer Takvimi"
                              sheet="tablexls"
                              buttonText="Seminer Takvimi Oluştur"
                            />
                          </>
                        ) : null}
                      </div>
                    </div>
                    {loading ? (
                      <Skeleton
                        baseColor="#e2e8f0"
                        width="100%"
                        count={3}
                        height={20}
                      />
                    ) : (
                      <table className="w-full table-auto">
                        <thead className="bg-slate-100">
                          <tr>
                            <td className="px-4 py-2 whitespace-nowrap">
                              Başvuru No
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap hidden lg:table-cell">
                              Öğrenci
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap hidden lg:table-cell">
                              Enstitü / Dönem
                            </td>
                            <td className="py-2">Durum</td>
                            <td className="py-2">İşlemler</td>
                          </tr>
                        </thead>
                        <tbody className="text-xs">
                          {seminerLIST?.filter(
                            (item) => item.seminerDurum === 2
                          ).length > 0 ? (
                            seminerLIST
                              .filter((item) => item.seminerDurum === 2)
                              .map((item, key) => (
                                <tr
                                  key={key}
                                  className="even:bg-slate-50 odd:bg-white"
                                >
                                  <td className="px-4 py-3 whitespace-nowrap">
                                    <strong className="underline">
                                      <Link
                                        to={
                                          '/seminer-print/' + item.seminerCode
                                        }
                                        target="blank"
                                      >
                                        {item.seminerCode}
                                      </Link>
                                    </strong>
                                    <dl className="lg:hidden">
                                      <dd className="">
                                        {item.ogrenci.ogrenciNo}
                                      </dd>
                                      <dd className="">
                                        {item.ogrenci.ogrenciAdiSoyadi}
                                      </dd>
                                      <dd className="">{item.enstituName}</dd>
                                    </dl>
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                                    <div>{item.ogrenci.ogrenciNo}</div>
                                    <div>{item.ogrenci.ogrenciAdiSoyadi}</div>
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                                    <div>{item.enstituName}</div>
                                    <div>{item.donem.donemName}</div>
                                  </td>
                                  <td className="py-3 whitespace-nowrap">
                                    {item.seminerDurum === 1 ? (
                                      <span className="bg-orange-200 text-orange-600 py-1 px-2 rounded-3xl">
                                        Bekliyor
                                      </span>
                                    ) : item.seminerDurum === 2 ? (
                                      <span className="bg-teal-200 text-teal-600 py-1 px-2 rounded-3xl">
                                        Onaylandı
                                      </span>
                                    ) : (
                                      <span className="bg-red-200 text-red-600 py-1 px-3 rounded-3xl">
                                        Rededildi
                                      </span>
                                    )}
                                  </td>
                                  <td className="py-3 whitespace-nowrap space-x-2">
                                    <button
                                      onClick={() => {
                                        setSeminerId(item.seminerId);
                                        setOpen(true);
                                      }}
                                      className="bg-sky-600 text-white hover:bg-sky-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-sky-400 outline-offset-2"
                                    >
                                      Görüntüle
                                    </button>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan={3} className="px-4 py-3">
                                Kayıt bulunamamıştır.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="bg-white rounded-lg p-4 min-h-0 overflow-x-auto">
                    <h1 className="mb-4 font-semibold">Rededilen Başvurular</h1>
                    {loading ? (
                      <Skeleton
                        baseColor="#e2e8f0"
                        width="100%"
                        count={3}
                        height={20}
                      />
                    ) : (
                      <table className="w-full table-auto">
                        <thead className="bg-slate-100">
                          <tr>
                            <td className="px-4 py-2 whitespace-nowrap">
                              Başvuru No
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap hidden lg:table-cell">
                              Öğrenci
                            </td>
                            <td className="px-4 py-2 whitespace-nowrap hidden lg:table-cell">
                              Enstitü / Dönem
                            </td>
                            <td className="py-2">Durum</td>
                            <td className="py-2">İşlemler</td>
                          </tr>
                        </thead>
                        <tbody className="text-xs">
                          {seminerLIST?.filter(
                            (item) => item.seminerDurum === 3
                          ).length > 0 ? (
                            seminerLIST
                              .filter((item) => item.seminerDurum === 3)
                              .map((item, key) => (
                                <tr
                                  key={key}
                                  className="even:bg-slate-50 odd:bg-white"
                                >
                                  <td className="px-4 py-3 whitespace-nowrap">
                                    <strong className="underline">
                                      <Link
                                        to={
                                          '/seminer-print/' + item.seminerCode
                                        }
                                        target="blank"
                                      >
                                        {item.seminerCode}
                                      </Link>
                                    </strong>
                                    <dl className="lg:hidden">
                                      <dd className="">
                                        {item.ogrenci.ogrenciNo}
                                      </dd>
                                      <dd className="">
                                        {item.ogrenci.ogrenciAdiSoyadi}
                                      </dd>
                                      <dd className="">{item.enstituName}</dd>
                                    </dl>
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                                    <div>{item.ogrenci.ogrenciNo}</div>
                                    <div>{item.ogrenci.ogrenciAdiSoyadi}</div>
                                  </td>
                                  <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                                    <div>{item.enstituName}</div>
                                    <div>{item.donem.donemName}</div>
                                  </td>
                                  <td className="py-3 whitespace-nowrap">
                                    {item.seminerDurum === 1 ? (
                                      <span className="bg-orange-200 text-orange-600 py-1 px-2 rounded-3xl">
                                        Bekliyor
                                      </span>
                                    ) : item.seminerDurum === 2 ? (
                                      <span className="bg-teal-200 text-teal-600 py-1 px-2 rounded-3xl">
                                        Onaylandı
                                      </span>
                                    ) : (
                                      <span className="bg-red-200 text-red-600 py-1 px-3 rounded-3xl">
                                        Rededildi
                                      </span>
                                    )}
                                  </td>
                                  <td className="py-3 whitespace-nowrap space-x-2">
                                    <button
                                      onClick={() => {
                                        setSeminerId(item.seminerId);
                                        setOpen(true);
                                      }}
                                      className="bg-sky-600 text-white hover:bg-sky-700 py-1 px-3 rounded-3xl outline-dashed outline-1 focus:outline-sky-400 outline-offset-2"
                                    >
                                      Görüntüle
                                    </button>
                                  </td>
                                </tr>
                              ))
                          ) : (
                            <tr>
                              <td colSpan={3} className="px-4 py-3">
                                Kayıt bulunamamıştır.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={setOpen}>
          <div className="fixed inset-0" />

          <div className="fixed inset-0 overflow-hidden">
            <div className="absolute inset-0 overflow-hidden">
              <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <Transition.Child
                  as={Fragment}
                  enter="transform transition ease-in-out duration-500 sm:duration-700"
                  enterFrom="translate-x-full"
                  enterTo="translate-x-0"
                  leave="transform transition ease-in-out duration-500 sm:duration-700"
                  leaveFrom="translate-x-0"
                  leaveTo="translate-x-full"
                >
                  <Dialog.Panel className="pointer-events-auto w-screen max-w-2xl">
                    <div className="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
                      <div className="px-4 sm:px-6">
                        <div className="flex items-start justify-between">
                          <Dialog.Title className="text-base font-semibold leading-6 text-slate-500"></Dialog.Title>
                          <div className="ml-3 flex h-7 items-center">
                            <button
                              type="button"
                              className="rounded-md bg-white text-slate-400 hover:text-slate-500"
                              onClick={() => setOpen(false)}
                            >
                              <span className="sr-only">Close panel</span>
                              <BsXLg className="h-6 w-6" aria-hidden="true" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div className="relative mt-6 px-4 sm:px-6 text-slate-500">
                        {seminerLIST
                          ?.filter((item) => item.seminerId === seminerId)
                          .map((item, key) => (
                            <div key={key} className="text-xs">
                              <div className="space-y-1">
                                <div className="font-semibold text-xl">
                                  {item.ogrenci.ogrenciAdiSoyadi}
                                </div>
                                <div className="divide-x-2">
                                  <span className="pr-4">
                                    <a href="mailto:selim@odu.edu.tr">
                                      {item.ogrenci.ogrenciEposta}
                                    </a>
                                  </span>
                                  <span className="pl-4">
                                    {item.ogrenci.ogrenciCepNo}
                                  </span>
                                </div>
                                <div>{item.ogrenci.ogrenciNo}</div>
                                <div>{item.enstituName}</div>
                                <div>
                                  {item.anabilimName} /{' '}
                                  {item.bilimsanatdaliName}
                                </div>
                              </div>
                              <div className="mt-8">
                                <h1 className="font-semibold text-sm text-slate-700 mb-4">
                                  Seminer Detay
                                </h1>
                                <div>
                                  <table className="w-full">
                                    <tbody>
                                      <tr>
                                        <td className="border border-slate-200 p-2 font-semibold text-slate-700">
                                          Seminer Türü
                                        </td>
                                        <td className="border border-slate-200 p-2">
                                          {item.seminerTuru}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="border border-slate-200 p-2 font-semibold text-slate-700">
                                          Seminer tarihi ve saati
                                        </td>
                                        <td className="border border-slate-200 p-2">
                                          {item.seminerTarihi} -{' '}
                                          {item.seminerSaati}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="border border-slate-200 p-2 font-semibold text-slate-700">
                                          Seminerin yapılacağı yer
                                        </td>
                                        <td className="border border-slate-200 p-2">
                                          {item.seminerYeri}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          colSpan={2}
                                          className="border border-slate-200 p-2"
                                        >
                                          <div className="mb-2 font-semibold text-slate-700">
                                            Seminer Konusu
                                          </div>
                                          <p>{item.seminerKonusu}</p>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <table className="hidden table-auto w-full mt-8" id="tablo">
        <thead className="bg-slate-100 text-xs">
          <tr>
            <td className="table-cell whitespace-nowrap px-3 py-2">
              Öğrenci No
            </td>
            <td className="table-cell whitespace-nowrap px-3 py-2">
              Adı Soyadı
            </td>
            <td className="table-cell whitespace-nowrap px-3 py-2">
              Seminer Türü
            </td>
            <td className="table-cell whitespace-nowrap px-3 py-2">Program</td>
            <td className="table-cell whitespace-nowrap px-3 py-2">
              Anabilim/Anasanat Dalı
            </td>
            <td className="table-cell whitespace-nowrap px-3 py-2">
              Bilim/Sanat Dalı
            </td>
            <td className="table-cell whitespace-nowrap px-3 py-2">
              Seminer Konusu
            </td>
            <td className="table-cell whitespace-nowrap px-3 py-2">
              Tarih /Saat
            </td>
            <td className="table-cell whitespace-nowrap px-3 py-2">Yer</td>
          </tr>
        </thead>
        <tbody className="text-xs">
          {seminerLIST
            ?.filter((item) => item.seminerDurum === 2)
            .map((item, key) => (
              <tr key={key} className="even:bg-slate-50 odd:bg-white">
                <td className="table-cell px-2 py-1">
                  {item.ogrenci.ogrenciNo}
                </td>
                <td className="table-cell px-2 py-1">
                  {item.ogrenci.ogrenciAdiSoyadi}
                </td>
                <td className="table-cell px-2 py-1">{item.seminerTuru}</td>
                <td className="table-cell px-2 py-1">{item.seminerProgrami}</td>
                <td className="table-cell px-2 py-1">{item.anabilimName}</td>
                <td className="table-cell px-2 py-1">
                  {item.bilimsanatdaliName}
                </td>
                <td className="table-cell px-2 py-1">{item.seminerKonusu}</td>
                <td className="table-cell px-2 py-1">
                  {item.seminerTarihi} / {item.seminerSaati}
                </td>
                <td className="table-cell px-2 py-1">{item.seminerYeri}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default TumBasvurular;
